// import coreTheme from 'gatsby-theme-core/src/layout/theme';

export default {};
